"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var mobx_1 = require("mobx");
require("../mutators/removeMessageAdMutator");
exports.getStore = satcheljs_1.createStore('messageAdStore', {
    adIds: [],
    messageAdRowStore: mobx_1.map({}),
});
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-messagead-store/lib/store/store.js
// module id = 2802
// module chunks = 17 67